export default __webpack_public_path__ + "placeholder60x60.2d2171197793bdfc2119b4256863d1dd.png";